// import Vue from 'vue'
// import { queryQuoteInfo } from '@/api/robotQuote'
const state = {
  robotQuoteDetail: {},
  
}
const mutations = {
  setRobotQuoteDetail (state, robotQuoteDetail) {
    state.robotQuoteDetail = robotQuoteDetail
  },
}
const actions = {
  // async getQuoteDetail({ commit }, params) {
  //   const res = await queryQuoteInfo(params)
  //   if(!res.success || !res.model) return
  //   res.model.detail_parts_alias_list.unshift('全部品类')
  //   res.model.detail_parts_brand_list.unshift('全部')
  //   commit('setRobotQuoteDetail', res.model)
  // }
}
const modules = {
}

export default {
  state,
  mutations,
  actions,
  modules,
  namespaced: true
}